import {SubPageHeader} from "../SubPageHeader";
import React from "react";
import './ChurchHistory.css'
import Footer from "../Footer";

function ChurchHistory() {
    return (
        <>
            <SubPageHeader title='Church History'/>
            <div className='sub-page-container'>
                <div className='sub-page-content'>
                    <p>On Sunday, January 2, 2000, with burden and a beckoning call from the Lord to leave the
                        traditions of men and bring the church back to scriptural principles, Ekklesia Ministries was
                        established. Worship services and Mid-Week Insight Bible Study were held at the Ramada Inn Hotel
                        and Conference Center in Sheffield, Alabama for the first month. Thereafter, an abandoned night
                        club was leased in Muscle Shoals, Alabama and the work began to display kingdom excellence as
                        the ministry experienced explosive growth spiritually and numerically. Within the first two
                        months, the membership grew to over 100 active members and three full-time staff members were
                        added.</p>

                    <p>During the second year, we continued to experience exponential growth and set our sights on our
                        current location which previously housed the Shoals Renewal and Conference Center. Ekklesia
                        laborers were very familiar with this property because we frequently visited for baptismal
                        services. However, the parking presented a challenge for our growing congregation. As an act of
                        faith, our pastor approached the neighboring homeowner and asked, “What will it take for you to
                        move?” He explained that we wanted to buy the property at 3007 Hatch Boulevard (Sheffield,
                        Alabama) and we needed the adjacent property at 3003 Hatch Boulevard for the deal to work. With
                        a little negotiating, they made a gentlemen’s agreement with a handshake and a thank you!
                        However, this additional land provided temporary resolve and growth provided more of the same
                        welcomed challenges. Thus, plans were made to purchase additional property across the street at
                        1510 W 31st Street in Sheffield.</p>

                    <p>In 2003, Ekklesia Pre-School & Child Development Center-Sheffield was established. In June 2012,
                        Ekklesia Ministries launched its second campus in the city of Corinth, Mississippi located at
                        2066 South Tate Street. In 2018, we were blessed to extend our boarders and lengthen our cords
                        to establish Ekklesia Pre-School & Child Development Center – Florence.</p>

                    <p>Ekklesia Ministries is “A Christ-Centered, Spirit-Filled, New Creation Church” based on 2
                        Corinthians 5:17 – “And if any man be in Christ he is a new creation.” We are a cutting-edge
                        fellowship of believers without the walls of denomination and the traditions of men. Ekklesia is
                        in covenant with the Whole Truth Ministry under Apostle Dr. Maurice K. (Dr. Brenda) Wright of
                        United Christian Church in located in Gadsden, Alabama for accountability and mentorship.</p>
                </div>
            </div>
            <Footer/>
            }
        </>
    )
}

export default ChurchHistory;